var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertyHolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property_Holder",
    "data-name": "Property Holder",
    transform: "translate(-1459 -447)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rectangle",
    width: 20,
    height: 20,
    transform: "translate(1459 447)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M6.833,11.667C4.889,11.667,1,12.639,1,14.583v2.082H12.667V14.583c0-1.944-3.888-2.917-5.833-2.917m6.667,0a7.938,7.938,0,0,0-.8.045,3.5,3.5,0,0,1,1.637,2.872v2.082h5V14.583c0-1.944-3.887-2.917-5.832-2.917M6.833,5A2.5,2.5,0,1,0,9.326,7.5,2.5,2.5,0,0,0,6.833,5M13.5,5a2.5,2.5,0,1,0,2.491,2.5A2.5,2.5,0,0,0,13.5,5",
    transform: "translate(1458.833 446.167)",
    fill: "current",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyHolder);
export default __webpack_public_path__ + "static/media/Property-Holder.a74fbc554220dc0752ce3308813be0ff.svg";
export { ForwardRef as ReactComponent };